import db from '@/fb'

export default {
    setNodesAction({commit}, payload) {
    }
}